import { CdkNoDataRow } from '@angular/cdk/table';
import { Directive } from '@angular/core';

/** Row that can be used to display a message when no data is shown in the table. */
@Directive({
  selector: 'ng-template[nNoDataRow]',
  providers: [{ provide: CdkNoDataRow, useExisting: NNoDataRowDirective }],
})
export class NNoDataRowDirective extends CdkNoDataRow {
  override _contentClassName = 'n-no-data-row';
}
